import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=83ae0828&"
import script from "./Key.vue?vue&type=script&lang=js&"
export * from "./Key.vue?vue&type=script&lang=js&"
import style0 from "./Key.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports